<template>
  <div class="steps">
    <div class="steps_tabs" role="tablist">
      <button
        v-for="(step, i) in steps"
        :key="step.title"
        :id="`step-tab-${i}`"
        class="steps_tab"
        :class="{ is_active: i === active }"
        type="button"
        role="tab"
        :aria-selected="i === active"
        :aria-controls="`step-panel-${i}`"
        @click="active = i"
      >
        <span class="steps_number">{{ number(i) }}</span>
        <span class="steps_title">{{ step.title }}</span>
      </button>
    </div>

    <div
      v-for="(step, i) in steps"
      v-show="i === active"
      :key="step.title"
      :id="`step-panel-${i}`"
      class="steps_panel"
      role="tabpanel"
      :aria-labelledby="`step-tab-${i}`"
    >
      <p class="steps_number">{{ number(i) }}</p>
      <h3>{{ step.title }}</h3>
      <p>{{ step.text }}</p>
    </div>
  </div>
</template>

<script>
// The numbered "how it works" tabs. `steps` is [{ title, text }].

export default {
  name: 'SiteSteps',

  props: {
    steps: { type: Array, required: true },
  },

  data() {
    return { active: 0 }
  },

  methods: {
    number(index) {
      return String(index + 1).padStart(2, '0')
    },
  },
}
</script>

<style scoped>
.steps_tabs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.steps_tab {
  padding: 20px 24px;
  border: 1px solid var(--paper-line);
  border-radius: var(--radius);
  background: none;
  font: inherit;
  text-align: left;
  color: inherit;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.steps_tab.is_active {
  border-color: var(--ink);
  background: var(--ink);
  color: var(--ink-invert);
}

.steps_number {
  display: block;
  margin-bottom: 8px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.steps_title {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.steps_panel {
  padding: 32px;
  border-radius: var(--radius);
  background: var(--paper);
}

.steps_panel h3 {
  margin: 8px 0 16px;
}

@media (max-width: 1024px) {
  .steps_tabs {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .steps_tabs {
    grid-template-columns: 1fr;
  }

  .steps_panel {
    padding: 24px;
  }
}
</style>
